import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { styled } from '@mui/material';
import {
  EmailInput,
  PhoneField,
  TextField,
} from '@calefy-inc/informedMaterial';
import { useIsAdmin } from '../../../../../../hooks';
import { useIsPolicyStreamOrganization } from '../../../../../PolicyStream/hooks/useIsPolicyStreamOrganization';
import {
  withFormStyles,
  WithFormStyles,
} from '../../../../../../util/withFormStyles';
import {
  WhiteLabelSectionDivider,
  WhiteLabelSectionRoot,
} from './whiteLabelSectionCommon';
import { validateGoogleAnalyticsToken } from '../whiteLabelSettingsFormHelpers';

export const CompanyInfoSection = withFormStyles()(function CompanyInfoSection({
  classes,
}: WithFormStyles) {
  const isAdmin = useIsAdmin();
  const isPolicyStreamOnlyOrganization = useIsPolicyStreamOrganization();

  return (
    <WhiteLabelSectionRoot>
      <Typography variant='h6' gutterBottom>
        Company Info
      </Typography>
      <WhiteLabelSectionDivider />

      <FieldsGrid>
        {isAdmin ? (
          <TextField
            name='slug'
            label='Slug'
            variant='standard'
            fullWidth
            className={classes.textfield}
          />
        ) : null}
        {isAdmin ? (
          <TextField
            name='host'
            label='Host'
            variant='standard'
            fullWidth
            className={classes.textfield}
          />
        ) : null}

        <TextField
          name='companyName'
          label='Company Name'
          variant='standard'
          fullWidth
          className={classes.textfield}
        />
        {/* informedMaterial PhoneField / EmailInput only attach format validators when `required`. */}
        <PhoneField
          name='phone'
          label='Phone'
          required={false}
          variant='standard'
          fullWidth
          validateOnChange
          className={classes.phonefield}
        />
        <EmailInput
          name='email'
          label='Email'
          required={false}
          variant='standard'
          fullWidth
          validateOnChange
          className={classes.emailinput}
        />
        <TextField
          name='hours'
          label='Hours'
          variant='standard'
          fullWidth
          className={classes.textfield}
        />
        <TextField
          name='chatLink'
          label='Chat Link'
          variant='standard'
          fullWidth
          className={classes.textfield}
        />
        <TextField
          name='privacyLink'
          label='Privacy Link'
          variant='standard'
          fullWidth
          className={classes.textfield}
        />
        <TextField
          name='title'
          label='Title'
          variant='standard'
          fullWidth
          className={classes.textfield}
        />
        <TextField
          name='homepage'
          label='Homepage URL'
          variant='standard'
          fullWidth
          className={classes.textfield}
        />
        <TextField
          name='googleAnalyticsToken'
          label='Google Tag ID (GTM-... or G-...)'
          validate={validateGoogleAnalyticsToken}
          validateOnChange
          variant='standard'
          fullWidth
          className={classes.textfield}
        />
      </FieldsGrid>

      {!isPolicyStreamOnlyOrganization ? (
        <ThankYouBlock>
          <TextField
            name='thankYouText'
            label='Thank You Text'
            variant='standard'
            fullWidth
            multiline
            rows={3}
            className={classes.textarea}
          />
        </ThankYouBlock>
      ) : null}
    </WhiteLabelSectionRoot>
  );
});

/** Responsive two-column grid for standard text fields */
const FieldsGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: '1fr 1fr',
  },
}));

/** Full-width block below the grid (e.g. multiline thank-you text) */
const ThankYouBlock = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));
